import { Builder } from '@builder.io/react';

import { AccessForm } from './index';

Builder.registerComponent(AccessForm, {
  name: 'Summit Access Form',
  inputs: [
    {
      name: 'dates',
      type: 'string',
      defaultValue: 'NOVEMBER 1ST - 3RD, 2023'
    },
    {
      name: 'place',
      type: 'string',
      defaultValue: 'Park City, Utah'
    },
    {
      name: 'subtitle',
      type: 'string',
      defaultValue:
        'Join Scale AI as we bring together the world’s brightest AI leaders, visionaries.'
    }
  ]
});
